import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingLarge} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

import type {Images, Strings} from "./types.ts";

type Props = {
    strings: Strings;
    images: Images;
};

export default class Details extends React.Component<Props> {
    render(): React.ReactNode {
        const {strings, images} = this.props;

        return (
            <View style={styles.detailsWrapper}>
                <View style={styles.illustration}>
                    <img
                        alt={t`Screenshot`}
                        src={staticUrl(images.learn)}
                        className={css(styles.bulletImg)}
                    />
                </View>
                <View style={styles.details}>
                    <HeadingLarge>{strings.learnWithYourStudents}</HeadingLarge>
                    <Body style={styles.description}>
                        {strings.learnWithYourStudentsDescription}
                    </Body>
                    <View style={styles.ctaButton}>
                        <Button href={strings.khanForEducatorsUrl}>
                            {strings.trainingCta}
                        </Button>
                    </View>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    detailsWrapper: {
        backgroundColor: color.offWhite,
        width: "100%",
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: 64,
        marginBottom: 48,
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column-reverse",
        },
    },
    details: {
        maxWidth: 400,
    },
    description: {
        marginTop: 24,
        marginBottom: 48,
    },
    illustration: {
        flexDirection: "row",
        justifyContent: "flex-end",
        paddingRight: 80,
        [mediaQueries.smOrSmaller]: {
            justifyContent: "center",
            paddingRight: 0,
            marginTop: 40,
        },
    },
    bulletImg: {
        width: 371,
        height: 221,
        [mediaQueries.mdOrSmaller]: {
            width: 300,
            height: 200,
        },
        [mediaQueries.smOrSmaller]: {
            width: 200,
            height: 125,
        },
    },
    ctaButton: {
        width: 220,
    },
});
